import { KeyboardEvent } from "react";

export const keyDownA11y = (handler: () => void) => {
  return function onKeyDown(event: KeyboardEvent) {
    if (["keydown", "keypress"].includes(event.type) && ["Enter", " "].includes(event.key)) {
      handler();
    }
  };
};
